/** Contains several constant definitions for expressions tag */
export var ExprTag;
(function (ExprTag) {
    /** Unknown expression */
    ExprTag[ExprTag["Unknown"] = 0] = "Unknown";
    /** Constant expression */
    ExprTag[ExprTag["Constant"] = 1] = "Constant";
    /** Entity attributre expression */
    ExprTag[ExprTag["EntityAttribute"] = 2] = "EntityAttribute";
    /** Parent entity attribute expression */
    ExprTag[ExprTag["ParentEntityAttribute"] = 3] = "ParentEntityAttribute";
    /** Agrregate function expression */
    ExprTag[ExprTag["AggregateFunction"] = 4] = "AggregateFunction";
    /** Parent column expression */
    ExprTag[ExprTag["ParentColumn"] = 5] = "ParentColumn";
    /** Query expression */
    ExprTag[ExprTag["Query"] = 11] = "Query";
    /** Custom sql expression */
    ExprTag[ExprTag["CustomSql"] = 21] = "CustomSql";
})(ExprTag || (ExprTag = {}));
//# sourceMappingURL=expr_tag.js.map